import { ReactHookFormDatepicker as Datepicker } from '@/containers/forms/Datepicker'
import { Button, Flex, FormControl } from '@chakra-ui/react'
import type { InsuranceAdditionalDatesModel } from 'BrokerTsLib/src/dtos'
import { FormProvider, useForm } from 'BrokerTsLib/src/rhf'

import { FormRow } from '@/containers/forms/FormRow'
import { useCallback } from 'react'
import { FormLabel } from './FormLabel'

interface AddInsuranceAdditionalDatesFormProps {
  data: InsuranceAdditionalDatesModel,
  onSubmit: (values: InsuranceAdditionalDatesModel) => Promise<any>
}

export const AddInsuranceAdditionalDatesForm = ({ data, onSubmit }: AddInsuranceAdditionalDatesFormProps) => {
  const methods = useForm<InsuranceAdditionalDatesModel>({
    defaultValues: data,
  })

  const { handleSubmit, register, formState } = methods
  const { errors, isSubmitting } = formState

  const handleFormSubmit =
    useCallback(handleSubmit((values: InsuranceAdditionalDatesModel) => onSubmit(values)), [handleSubmit])

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleFormSubmit}>
        <FormRow itemsCount={1}>

          <FormControl>
            <FormLabel>Datum převzetí pojišťovacím makléřem</FormLabel>

            <Datepicker
              name='contractDeliveryDate'
            />
          </FormControl>

          <FormControl>
            <FormLabel>Datum zaplacení 1. splátky</FormLabel>

            <Datepicker
              name='firstPaymentDate'
            />
          </FormControl>

          <FormControl>
            <FormLabel>Datum vyplacení provize</FormLabel>

            <Datepicker
              name='commissionPaidDate'
            />
          </FormControl>

        </FormRow>

        <Flex mt={4} justifyContent='center'>
          <Button
            variant="solid"
            colorScheme="primary"
            isLoading={isSubmitting}
            isDisabled={isSubmitting}
            onClick={handleFormSubmit}
          >
            Uložit
          </Button>
        </Flex>
      </form>
    </FormProvider>
  )
}
